// src/theme/colorScheme.js
// Modern Energy/EV-Inspired Color Scheme with Light Green Primary

export const colors = {
  primary: {
    main: '#10b981',     // Light green - Main primary color
    light: '#34d399',    // Lighter green for hover states
    dark: '#059669',     // Darker green for active states
    contrastText: '#ffffff'
  },
  secondary: {
    main: '#0e7490',     // Deep teal blue - Secondary color
    light: '#22a6c1',    // Lighter teal
    dark: '#0a536b',     // Darker teal
    contrastText: '#ffffff'
  },


  accent: {
    main: '#f59e0b',     // Soft orange - For call-to-action and important elements
    light: '#fbbf24',    // Lighter orange for hover
    dark: '#d97706',     // Darker orange for active states
    contrastText: '#ffffff'
  },
  background: {
    default: '#f9fafb',  // Light gray - Main background
    paper: '#ffffff',    // White - Card background
    dark: '#1e293b'      // Dark slate - Sidebar & headers
  },
  text: {
    primary: '#1e293b',  // Dark slate - Primary text
    secondary: '#64748b', // Medium gray - Secondary text
    disabled: '#94a3b8',  // Light gray - Disabled text
    hint: '#94a3b8'       // Light gray - Hint text
  },
  success: {
    main: '#10b981',     // Green - Success state (same as primary)
    light: '#34d399',
    dark: '#059669',
    contrastText: '#ffffff'
  },
  error: {
    main: '#ef4444',     // Red - Error state
    light: '#f87171',
    dark: '#dc2626',
    contrastText: '#ffffff'
  },
  warning: {
    main: '#f59e0b',     // Orange - Warning state
    light: '#fbbf24',
    dark: '#d97706',
    contrastText: '#ffffff'
  },
  info: {
    main: '#0ea5e9',     // Blue - Info state
    light: '#38bdf8',
    dark: '#0284c7',
    contrastText: '#ffffff'
  },
  divider: '#e2e8f0'     // Light gray - Dividers
};

// Custom color variables for specific application uses
export const customColors = {
  chargerOnline: '#10b981',        // Green for online chargers (same as primary)
  chargerOffline: '#94a3b8',       // Gray for offline chargers
  chargerCharging: '#0ea5e9',      // Blue for charging state
  chargerError: '#ef4444',         // Red for error state
  sidebarBackground: '#1e293b',    // Dark slate for sidebar
  headerBackground: '#1e293b',     // Dark slate for headers
  activeNavItem: '#10b981',        // Primary light green for active navigation
  energyChart: '#10b981',          // Light green for energy charts (same as primary)
  powerChart: '#0ea5e9',           // Blue for power charts
  
  // Status colors
  statusActive: '#10b981',         // Green for active status (same as primary)
  statusInactive: '#94a3b8',       // Gray for inactive status
  statusPending: '#f59e0b',        // Orange for pending status
  statusCompleted: '#0ea5e9',      // Blue for completed status
  statusFailed: '#ef4444'          // Red for failed status
};